/**
 * The usage-limit keys that the product actually reads and both admin writes accept.
 *
 * Fleet defaults and member overrides deliberately share this one definition. Adding a
 * field to one form without the other would give operators two different accounts of the
 * same resolution chain.
 */
export const WRITABLE_LIMITS: readonly {
  key: string;
  label: string;
  period: string;
  /** The effective allowance returned by the member read, when that read exposes this limit. */
  memberReadKey?: 'outfit_regen' | 'try_on_generation' | 'playground_try_on';
}[] = [
  {
    key: 'outfit_regens_per_day',
    label: 'Outfit regenerations',
    period: 'each day',
    memberReadKey: 'outfit_regen',
  },
  {
    key: 'try_on_generations_per_day',
    label: 'Try-ons',
    period: 'each day',
    memberReadKey: 'try_on_generation',
  },
  {
    key: 'playground_try_ons_per_day',
    label: 'Playground try-ons',
    period: 'each day',
    memberReadKey: 'playground_try_on',
  },
  { key: 'avatar_generations_per_day', label: 'Avatar generations', period: 'each day' },
  { key: 'body_scans_max', label: 'Body scans', period: 'in total, not per day' },
];

export type WritableLimit = number | 'unlimited' | null;

export function parseLimit(raw: string): { ok: true; value: WritableLimit } | { ok: false } {
  const text = raw.trim().toLowerCase();
  if (text === 'unlimited') return { ok: true, value: 'unlimited' };
  if (text === 'default') return { ok: true, value: null };
  if (!/^\d+$/.test(text)) return { ok: false };
  return { ok: true, value: Number(text) };
}
